module.exports = __webpack_public_path__ + "img/certificate-1-4.048acc7e.jpg";